import { render, staticRenderFns } from "./taskDetail2.vue?vue&type=template&id=591d4e4e&"
import script from "./taskDetail2.vue?vue&type=script&lang=js&"
export * from "./taskDetail2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports